type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Upload: any;
};

export enum AllowedRevitFunction {
  Structure = "Structure",
  Substrate = "Substrate",
  Thermal = "Thermal",
  Membrane = "Membrane",
  Finish1 = "Finish1",
  Finish2 = "Finish2",
}

export type Buildup = {
  id: Scalars["ID"];
  name: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  template?: Maybe<BuildupTemplate>;
  isArchived?: Maybe<Scalars["Boolean"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  layers?: Maybe<Array<Maybe<Layer>>>;
  /** Revit Parameters */
  absorptance?: Maybe<Scalars["String"]>;
  accessibilityPerformance?: Maybe<Scalars["String"]>;
  acousticPerformanceRw?: Maybe<Scalars["String"]>;
  acousticPerformanceRwCtr?: Maybe<Scalars["String"]>;
  airTightnessPerformance?: Maybe<Scalars["String"]>;
  assemblyCode?: Maybe<Scalars["String"]>;
  assemblyDescription?: Maybe<Scalars["String"]>;
  assetIdentifier?: Maybe<Scalars["String"]>;
  assetType?: Maybe<Scalars["String"]>;
  author?: Maybe<Scalars["String"]>;
  barCode?: Maybe<Scalars["String"]>;
  bimObjectName?: Maybe<Scalars["String"]>;
  bimspecGuid?: Maybe<Scalars["String"]>;
  bsBibleVersion?: Maybe<Scalars["String"]>;
  cavitySize?: Maybe<Scalars["String"]>;
  claddingType?: Maybe<Scalars["String"]>;
  coarseScaleFillColor?: Maybe<Scalars["String"]>;
  coarseScaleFillPattern?: Maybe<Scalars["String"]>;
  codePerformance?: Maybe<Scalars["String"]>;
  colour?: Maybe<Scalars["String"]>;
  connectionAccessories?: Maybe<Scalars["String"]>;
  connectionFasteners?: Maybe<Scalars["String"]>;
  constituents?: Maybe<Scalars["String"]>;
  constructionType?: Maybe<Scalars["String"]>;
  cost?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<Scalars["String"]>;
  currentRevision?: Maybe<Scalars["String"]>;
  designOfFramingSystems?: Maybe<Scalars["String"]>;
  dimensionalConstraints?: Maybe<Scalars["String"]>;
  distributedBy?: Maybe<Scalars["String"]>;
  durationUnit?: Maybe<Scalars["String"]>;
  expectedLife?: Maybe<Scalars["String"]>;
  externalAirGap?: Maybe<Scalars["String"]>;
  externalBracketCentres?: Maybe<Scalars["String"]>;
  externalCladdingMaterial?: Maybe<Scalars["String"]>;
  externalCladdingRestraint?: Maybe<Scalars["String"]>;
  externalInsulation?: Maybe<Scalars["String"]>;
  externalSheathingBoard?: Maybe<Scalars["String"]>;
  features?: Maybe<Scalars["String"]>;
  finish?: Maybe<Scalars["String"]>;
  firePerformanceExternalFaceInsulation?: Maybe<Scalars["String"]>;
  firePerformanceExternalFaceIntegrity?: Maybe<Scalars["String"]>;
  firePerformanceExternalFaceLoadBearing?: Maybe<Scalars["String"]>;
  firePerformanceInsideFaceInsulation?: Maybe<Scalars["String"]>;
  firePerformanceInsideFaceIntegrity?: Maybe<Scalars["String"]>;
  firePerformanceInsideFaceLoadBearing?: Maybe<Scalars["String"]>;
  fireRating?: Maybe<Scalars["Float"]>;
  framing?: Maybe<Scalars["String"]>;
  framingMembers?: Maybe<Scalars["String"]>;
  function?: Maybe<Scalars["String"]>;
  gapBetweenWallLinerAndFraming?: Maybe<Scalars["String"]>;
  grade?: Maybe<Scalars["String"]>;
  heatTransferCoefficient?: Maybe<Scalars["String"]>;
  ifcExportAs?: Maybe<Scalars["String"]>;
  ifcExportType?: Maybe<Scalars["String"]>;
  independentWallLiner?: Maybe<Scalars["String"]>;
  installationDate?: Maybe<Scalars["String"]>;
  insulationBetweenFraming?: Maybe<Scalars["String"]>;
  insulationBetweenStuds?: Maybe<Scalars["String"]>;
  insulationInternalManufacturer?: Maybe<Scalars["String"]>;
  insulationExternalManufacturer?: Maybe<Scalars["String"]>;
  insulationThickness?: Maybe<Scalars["Float"]>;
  keynote?: Maybe<Scalars["String"]>;
  liningsFaceLayer?: Maybe<Scalars["String"]>;
  liningsFasteners?: Maybe<Scalars["String"]>;
  liningsInnerLayers?: Maybe<Scalars["String"]>;
  manufacturer?: Maybe<Scalars["String"]>;
  material?: Maybe<Scalars["String"]>;
  meansOfAdjustment?: Maybe<Scalars["String"]>;
  metwallTag?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  modelNumber?: Maybe<Scalars["String"]>;
  modelReference?: Maybe<Scalars["String"]>;
  movementJointConnections?: Maybe<Scalars["String"]>;
  nbsDescription?: Maybe<Scalars["String"]>;
  nbsNote?: Maybe<Scalars["String"]>;
  nbsOfficeMasterTag?: Maybe<Scalars["String"]>;
  nbsReference?: Maybe<Scalars["String"]>;
  nominalHeight?: Maybe<Scalars["String"]>;
  nominalLength?: Maybe<Scalars["String"]>;
  nominalWidth?: Maybe<Scalars["String"]>;
  plasterboardManufacturer?: Maybe<Scalars["String"]>;
  plasterboardType?: Maybe<Scalars["String"]>;
  plasterboardThickness?: Maybe<Scalars["Float"]>;
  replacementCost?: Maybe<Scalars["String"]>;
  roughness?: Maybe<Scalars["String"]>;
  serialNumber?: Maybe<Scalars["String"]>;
  shape?: Maybe<Scalars["String"]>;
  size?: Maybe<Scalars["String"]>;
  structuralDesignSupervisionAndChecking?: Maybe<Scalars["String"]>;
  structuralMaterial?: Maybe<Scalars["String"]>;
  structure?: Maybe<Scalars["String"]>;
  sustainabilityPerformance?: Maybe<Scalars["String"]>;
  systemAccessories?: Maybe<Scalars["String"]>;
  systemManufacturer?: Maybe<Scalars["String"]>;
  systemType?: Maybe<Scalars["String"]>;
  tagNumber?: Maybe<Scalars["String"]>;
  thermalMass?: Maybe<Scalars["String"]>;
  thermalPerformance?: Maybe<Scalars["String"]>;
  thermalResistance?: Maybe<Scalars["String"]>;
  typeComments?: Maybe<Scalars["String"]>;
  typeImage?: Maybe<Scalars["String"]>;
  typeMark?: Maybe<Scalars["String"]>;
  typeOfAnchor?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
  uValue?: Maybe<Scalars["Float"]>;
  value?: Maybe<Scalars["String"]>;
  vapourControlLayer?: Maybe<Scalars["String"]>;
  warrantyDescription?: Maybe<Scalars["String"]>;
  warrantyDurationLabour?: Maybe<Scalars["String"]>;
  warrantyDurationParts?: Maybe<Scalars["String"]>;
  warrantyDurationUnit?: Maybe<Scalars["String"]>;
  warrantyGuarantorLabour?: Maybe<Scalars["String"]>;
  warrantyGuarantorParts?: Maybe<Scalars["String"]>;
  warrantyStartDate?: Maybe<Scalars["String"]>;
  wallWidth?: Maybe<Scalars["Float"]>;
  width?: Maybe<Scalars["String"]>;
  wrappingAtEnds?: Maybe<Scalars["String"]>;
  wrappingAtInserts?: Maybe<Scalars["String"]>;
};

export type BuildupTemplate = {
  id: Scalars["ID"];
  name: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  buildups: Array<Maybe<Buildup>>;
  parameters?: Maybe<Array<Maybe<Scalars["String"]>>>;
  images?: Maybe<Array<Maybe<Image>>>;
  isArchived?: Maybe<Scalars["Boolean"]>;
};

export type CheckLatestBuildupChangesInput = {
  lastDateCheck?: Maybe<Scalars["String"]>;
};

export type CheckLatestBuildupChangesResponse = {
  buildups?: Maybe<Array<Maybe<Buildup>>>;
  templates?: Maybe<Array<Maybe<BuildupTemplate>>>;
};

export type CreateBuildupInput = {
  name: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  templateId: Scalars["String"];
  isArchived?: Maybe<Scalars["Boolean"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  layers?: Maybe<Array<Maybe<CreateBuildupLayerInput>>>;
  /** Revit Parameters */
  absorptance?: Maybe<Scalars["String"]>;
  accessibilityPerformance?: Maybe<Scalars["String"]>;
  acousticPerformanceRw?: Maybe<Scalars["String"]>;
  acousticPerformanceRwCtr?: Maybe<Scalars["String"]>;
  airTightnessPerformance?: Maybe<Scalars["String"]>;
  assemblyCode?: Maybe<Scalars["String"]>;
  assemblyDescription?: Maybe<Scalars["String"]>;
  assetIdentifier?: Maybe<Scalars["String"]>;
  assetType?: Maybe<Scalars["String"]>;
  author?: Maybe<Scalars["String"]>;
  barCode?: Maybe<Scalars["String"]>;
  bimObjectName?: Maybe<Scalars["String"]>;
  bimspecGuid?: Maybe<Scalars["String"]>;
  bsBibleVersion?: Maybe<Scalars["String"]>;
  cavitySize?: Maybe<Scalars["String"]>;
  claddingType?: Maybe<Scalars["String"]>;
  coarseScaleFillColor?: Maybe<Scalars["String"]>;
  coarseScaleFillPattern?: Maybe<Scalars["String"]>;
  codePerformance?: Maybe<Scalars["String"]>;
  colour?: Maybe<Scalars["String"]>;
  connectionAccessories?: Maybe<Scalars["String"]>;
  connectionFasteners?: Maybe<Scalars["String"]>;
  constituents?: Maybe<Scalars["String"]>;
  constructionType?: Maybe<Scalars["String"]>;
  cost?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<Scalars["String"]>;
  currentRevision?: Maybe<Scalars["String"]>;
  designOfFramingSystems?: Maybe<Scalars["String"]>;
  dimensionalConstraints?: Maybe<Scalars["String"]>;
  distributedBy?: Maybe<Scalars["String"]>;
  durationUnit?: Maybe<Scalars["String"]>;
  expectedLife?: Maybe<Scalars["String"]>;
  externalAirGap?: Maybe<Scalars["String"]>;
  externalBracketCentres?: Maybe<Scalars["String"]>;
  externalCladdingMaterial?: Maybe<Scalars["String"]>;
  externalCladdingRestraint?: Maybe<Scalars["String"]>;
  externalInsulation?: Maybe<Scalars["String"]>;
  externalSheathingBoard?: Maybe<Scalars["String"]>;
  features?: Maybe<Scalars["String"]>;
  finish?: Maybe<Scalars["String"]>;
  firePerformanceExternalFaceInsulation?: Maybe<Scalars["String"]>;
  firePerformanceExternalFaceIntegrity?: Maybe<Scalars["String"]>;
  firePerformanceExternalFaceLoadBearing?: Maybe<Scalars["String"]>;
  firePerformanceInsideFaceInsulation?: Maybe<Scalars["String"]>;
  firePerformanceInsideFaceIntegrity?: Maybe<Scalars["String"]>;
  firePerformanceInsideFaceLoadBearing?: Maybe<Scalars["String"]>;
  fireRating?: Maybe<Scalars["Float"]>;
  framing?: Maybe<Scalars["String"]>;
  framingMembers?: Maybe<Scalars["String"]>;
  function?: Maybe<Scalars["String"]>;
  gapBetweenWallLinerAndFraming?: Maybe<Scalars["String"]>;
  grade?: Maybe<Scalars["String"]>;
  heatTransferCoefficient?: Maybe<Scalars["String"]>;
  ifcExportAs?: Maybe<Scalars["String"]>;
  ifcExportType?: Maybe<Scalars["String"]>;
  independentWallLiner?: Maybe<Scalars["String"]>;
  installationDate?: Maybe<Scalars["String"]>;
  insulationBetweenFraming?: Maybe<Scalars["String"]>;
  insulationBetweenStuds?: Maybe<Scalars["String"]>;
  insulationInternalManufacturer?: Maybe<Scalars["String"]>;
  insulationExternalManufacturer?: Maybe<Scalars["String"]>;
  insulationThickness?: Maybe<Scalars["Float"]>;
  keynote?: Maybe<Scalars["String"]>;
  liningsFaceLayer?: Maybe<Scalars["String"]>;
  liningsFasteners?: Maybe<Scalars["String"]>;
  liningsInnerLayers?: Maybe<Scalars["String"]>;
  manufacturer?: Maybe<Scalars["String"]>;
  material?: Maybe<Scalars["String"]>;
  meansOfAdjustment?: Maybe<Scalars["String"]>;
  metwallTag?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  modelNumber?: Maybe<Scalars["String"]>;
  modelReference?: Maybe<Scalars["String"]>;
  movementJointConnections?: Maybe<Scalars["String"]>;
  nbsDescription?: Maybe<Scalars["String"]>;
  nbsNote?: Maybe<Scalars["String"]>;
  nbsOfficeMasterTag?: Maybe<Scalars["String"]>;
  nbsReference?: Maybe<Scalars["String"]>;
  nominalHeight?: Maybe<Scalars["String"]>;
  nominalLength?: Maybe<Scalars["String"]>;
  nominalWidth?: Maybe<Scalars["String"]>;
  plasterboardManufacturer?: Maybe<Scalars["String"]>;
  plasterboardType?: Maybe<Scalars["String"]>;
  plasterboardThickness?: Maybe<Scalars["Float"]>;
  replacementCost?: Maybe<Scalars["String"]>;
  roughness?: Maybe<Scalars["String"]>;
  serialNumber?: Maybe<Scalars["String"]>;
  shape?: Maybe<Scalars["String"]>;
  size?: Maybe<Scalars["String"]>;
  structuralDesignSupervisionAndChecking?: Maybe<Scalars["String"]>;
  structuralMaterial?: Maybe<Scalars["String"]>;
  structure?: Maybe<Scalars["String"]>;
  sustainabilityPerformance?: Maybe<Scalars["String"]>;
  systemAccessories?: Maybe<Scalars["String"]>;
  systemManufacturer?: Maybe<Scalars["String"]>;
  systemType?: Maybe<Scalars["String"]>;
  tagNumber?: Maybe<Scalars["String"]>;
  thermalMass?: Maybe<Scalars["String"]>;
  thermalPerformance?: Maybe<Scalars["String"]>;
  thermalResistance?: Maybe<Scalars["String"]>;
  typeComments?: Maybe<Scalars["String"]>;
  typeImage?: Maybe<Scalars["String"]>;
  typeMark?: Maybe<Scalars["String"]>;
  typeOfAnchor?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
  uValue?: Maybe<Scalars["Float"]>;
  value?: Maybe<Scalars["String"]>;
  vapourControlLayer?: Maybe<Scalars["String"]>;
  warrantyDescription?: Maybe<Scalars["String"]>;
  warrantyDurationLabour?: Maybe<Scalars["String"]>;
  warrantyDurationParts?: Maybe<Scalars["String"]>;
  warrantyDurationUnit?: Maybe<Scalars["String"]>;
  warrantyGuarantorLabour?: Maybe<Scalars["String"]>;
  warrantyGuarantorParts?: Maybe<Scalars["String"]>;
  warrantyStartDate?: Maybe<Scalars["String"]>;
  wallWidth?: Maybe<Scalars["Float"]>;
  width?: Maybe<Scalars["String"]>;
  wrappingAtEnds?: Maybe<Scalars["String"]>;
  wrappingAtInserts?: Maybe<Scalars["String"]>;
};

export type CreateBuildupLayerInput = {
  material: Scalars["String"];
  revitFunction: Scalars["String"];
  structuralMaterial: Scalars["Boolean"];
  width: Scalars["Float"];
  wraps: Scalars["Boolean"];
};

export type CreateBuildupTemplate = {
  name: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  parameters?: Maybe<Array<Maybe<Scalars["String"]>>>;
  images?: Maybe<Array<Maybe<Scalars["Upload"]>>>;
};

export type CreateLayerInput = {
  arrayIndex: Scalars["Float"];
  revitFunction: AllowedRevitFunction;
  material: Scalars["String"];
  width: Scalars["Float"];
  wraps: Scalars["Boolean"];
  structuralMaterial: Scalars["Boolean"];
  buildupId: Scalars["String"];
};

export type CreateMaterialInput = {
  name: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  materialFile: Scalars["Upload"];
};

export type CreateUserInput = {
  email: Scalars["String"];
  password: Scalars["String"];
  role: Role;
};

export type DeleteBuildupInput = {
  id: Scalars["String"];
};

export type Filter = {
  id: Scalars["String"];
  parameter: Scalars["String"];
  operator: Scalars["String"];
  values: Array<Maybe<Scalars["String"]>>;
};

export type GeneratePdfInput = {
  filters: Array<Maybe<Filter>>;
  buildupId: Scalars["String"];
};

export type GeneratePdfResponse = {
  location?: Maybe<Scalars["String"]>;
};

export type Image = {
  id: Scalars["ID"];
  name: Scalars["String"];
  location?: Maybe<Scalars["String"]>;
  template?: Maybe<BuildupTemplate>;
};

export type Layer = {
  id: Scalars["ID"];
  arrayIndex: Scalars["Float"];
  revitFunction: AllowedRevitFunction;
  material: Material;
  width: Scalars["Float"];
  wraps: Scalars["Boolean"];
  structuralMaterial: Scalars["Boolean"];
  buildup: Buildup;
};

export type Material = {
  id: Scalars["ID"];
  name: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  downloadUrl?: Maybe<Scalars["String"]>;
  isArchived?: Maybe<Scalars["Boolean"]>;
};

export type Mutation = {
  dummy?: Maybe<Scalars["String"]>;
  createUser?: Maybe<User>;
  deleteUser?: Maybe<Scalars["Boolean"]>;
  resetPassword?: Maybe<Scalars["Boolean"]>;
  createBuildup: Buildup;
  deleteBuildup: Buildup;
  updateBuildup: Buildup;
  generatePDF: GeneratePdfResponse;
  createBuildupTemplate: BuildupTemplate;
  updateBuildupTemplate: BuildupTemplate;
  deleteBuildupTemplate: BuildupTemplate;
  createMaterial: Material;
  deleteMaterial?: Maybe<Material>;
  createLayer: Layer;
  deleteLayer: Layer;
  updateBuildupLayers: Array<Maybe<Layer>>;
  updateLayer?: Maybe<Layer>;
};

export type MutationCreateUserArgs = {
  data: CreateUserInput;
};

export type MutationDeleteUserArgs = {
  id: Scalars["String"];
};

export type MutationResetPasswordArgs = {
  id: Scalars["String"];
};

export type MutationCreateBuildupArgs = {
  input?: Maybe<CreateBuildupInput>;
};

export type MutationDeleteBuildupArgs = {
  id: Scalars["String"];
};

export type MutationUpdateBuildupArgs = {
  input?: Maybe<UpdateBuildupInput>;
};

export type MutationGeneratePdfArgs = {
  input?: Maybe<GeneratePdfInput>;
};

export type MutationCreateBuildupTemplateArgs = {
  input: CreateBuildupTemplate;
};

export type MutationUpdateBuildupTemplateArgs = {
  input: UpdateBuildupTemplate;
};

export type MutationDeleteBuildupTemplateArgs = {
  id?: Maybe<Scalars["String"]>;
};

export type MutationCreateMaterialArgs = {
  input: CreateMaterialInput;
};

export type MutationDeleteMaterialArgs = {
  id: Scalars["String"];
};

export type MutationCreateLayerArgs = {
  input: CreateLayerInput;
};

export type MutationDeleteLayerArgs = {
  id: Scalars["String"];
};

export type MutationUpdateBuildupLayersArgs = {
  input?: Maybe<UpdateBuildupLayersInput>;
};

export type MutationUpdateLayerArgs = {
  input?: Maybe<UpdateLayerInput>;
};

export type Query = {
  dummy?: Maybe<Scalars["String"]>;
  user?: Maybe<User>;
  users?: Maybe<Array<Maybe<User>>>;
  me?: Maybe<User>;
  buildup: Buildup;
  buildups: Array<Maybe<Buildup>>;
  checkLatestBuildupChanges: CheckLatestBuildupChangesResponse;
  buildupTemplate: BuildupTemplate;
  buildupTemplates: Array<Maybe<BuildupTemplate>>;
  material: Material;
  materials: Array<Maybe<Material>>;
  layer: Layer;
  layers: Array<Maybe<Layer>>;
};

export type QueryUserArgs = {
  id: Scalars["String"];
};

export type QueryBuildupArgs = {
  id: Scalars["String"];
};

export type QueryBuildupsArgs = {
  search?: Maybe<Scalars["String"]>;
  filters?: Maybe<Array<Maybe<Filter>>>;
  page?: Maybe<Scalars["Int"]>;
};

export type QueryCheckLatestBuildupChangesArgs = {
  input?: Maybe<CheckLatestBuildupChangesInput>;
};

export type QueryBuildupTemplateArgs = {
  id: Scalars["String"];
};

export type QueryBuildupTemplatesArgs = {
  page: Scalars["Int"];
};

export type QueryMaterialArgs = {
  id: Scalars["String"];
};

export type QueryLayerArgs = {
  id: Scalars["String"];
};

export type QueryLayersArgs = {
  buildupId: Scalars["String"];
};

export enum Role {
  Guest = "Guest",
  Editor = "Editor",
  Admin = "Admin"
}

export type Subscription = {
  dummy?: Maybe<Scalars["String"]>;
};

export type UpdateBuildupInput = {
  id: Scalars["String"];
  name: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  isArchived?: Maybe<Scalars["Boolean"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  /** Revit Parameters */
  absorptance?: Maybe<Scalars["String"]>;
  accessibilityPerformance?: Maybe<Scalars["String"]>;
  acousticPerformanceRw?: Maybe<Scalars["String"]>;
  acousticPerformanceRwCtr?: Maybe<Scalars["String"]>;
  airTightnessPerformance?: Maybe<Scalars["String"]>;
  assemblyCode?: Maybe<Scalars["String"]>;
  assemblyDescription?: Maybe<Scalars["String"]>;
  assetIdentifier?: Maybe<Scalars["String"]>;
  assetType?: Maybe<Scalars["String"]>;
  author?: Maybe<Scalars["String"]>;
  barCode?: Maybe<Scalars["String"]>;
  bimObjectName?: Maybe<Scalars["String"]>;
  bimspecGuid?: Maybe<Scalars["String"]>;
  bsBibleVersion?: Maybe<Scalars["String"]>;
  cavitySize?: Maybe<Scalars["String"]>;
  claddingType?: Maybe<Scalars["String"]>;
  coarseScaleFillColor?: Maybe<Scalars["String"]>;
  coarseScaleFillPattern?: Maybe<Scalars["String"]>;
  codePerformance?: Maybe<Scalars["String"]>;
  colour?: Maybe<Scalars["String"]>;
  connectionAccessories?: Maybe<Scalars["String"]>;
  connectionFasteners?: Maybe<Scalars["String"]>;
  constituents?: Maybe<Scalars["String"]>;
  constructionType?: Maybe<Scalars["String"]>;
  cost?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<Scalars["String"]>;
  currentRevision?: Maybe<Scalars["String"]>;
  designOfFramingSystems?: Maybe<Scalars["String"]>;
  dimensionalConstraints?: Maybe<Scalars["String"]>;
  distributedBy?: Maybe<Scalars["String"]>;
  durationUnit?: Maybe<Scalars["String"]>;
  expectedLife?: Maybe<Scalars["String"]>;
  externalAirGap?: Maybe<Scalars["String"]>;
  externalBracketCentres?: Maybe<Scalars["String"]>;
  externalCladdingMaterial?: Maybe<Scalars["String"]>;
  externalCladdingRestraint?: Maybe<Scalars["String"]>;
  externalInsulation?: Maybe<Scalars["String"]>;
  externalSheathingBoard?: Maybe<Scalars["String"]>;
  features?: Maybe<Scalars["String"]>;
  finish?: Maybe<Scalars["String"]>;
  firePerformanceExternalFaceInsulation?: Maybe<Scalars["String"]>;
  firePerformanceExternalFaceIntegrity?: Maybe<Scalars["String"]>;
  firePerformanceExternalFaceLoadBearing?: Maybe<Scalars["String"]>;
  firePerformanceInsideFaceInsulation?: Maybe<Scalars["String"]>;
  firePerformanceInsideFaceIntegrity?: Maybe<Scalars["String"]>;
  firePerformanceInsideFaceLoadBearing?: Maybe<Scalars["String"]>;
  fireRating?: Maybe<Scalars["Float"]>;
  framing?: Maybe<Scalars["String"]>;
  framingMembers?: Maybe<Scalars["String"]>;
  function?: Maybe<Scalars["String"]>;
  gapBetweenWallLinerAndFraming?: Maybe<Scalars["String"]>;
  grade?: Maybe<Scalars["String"]>;
  heatTransferCoefficient?: Maybe<Scalars["String"]>;
  ifcExportAs?: Maybe<Scalars["String"]>;
  ifcExportType?: Maybe<Scalars["String"]>;
  independentWallLiner?: Maybe<Scalars["String"]>;
  installationDate?: Maybe<Scalars["String"]>;
  insulationBetweenFraming?: Maybe<Scalars["String"]>;
  insulationBetweenStuds?: Maybe<Scalars["String"]>;
  insulationInternalManufacturer?: Maybe<Scalars["String"]>;
  insulationExternalManufacturer?: Maybe<Scalars["String"]>;
  insulationThickness?: Maybe<Scalars["Float"]>;
  keynote?: Maybe<Scalars["String"]>;
  liningsFaceLayer?: Maybe<Scalars["String"]>;
  liningsFasteners?: Maybe<Scalars["String"]>;
  liningsInnerLayers?: Maybe<Scalars["String"]>;
  manufacturer?: Maybe<Scalars["String"]>;
  material?: Maybe<Scalars["String"]>;
  meansOfAdjustment?: Maybe<Scalars["String"]>;
  metwallTag?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  modelNumber?: Maybe<Scalars["String"]>;
  modelReference?: Maybe<Scalars["String"]>;
  movementJointConnections?: Maybe<Scalars["String"]>;
  nbsDescription?: Maybe<Scalars["String"]>;
  nbsNote?: Maybe<Scalars["String"]>;
  nbsOfficeMasterTag?: Maybe<Scalars["String"]>;
  nbsReference?: Maybe<Scalars["String"]>;
  nominalHeight?: Maybe<Scalars["String"]>;
  nominalLength?: Maybe<Scalars["String"]>;
  nominalWidth?: Maybe<Scalars["String"]>;
  plasterboardManufacturer?: Maybe<Scalars["String"]>;
  plasterboardType?: Maybe<Scalars["String"]>;
  plasterboardThickness?: Maybe<Scalars["Float"]>;
  replacementCost?: Maybe<Scalars["String"]>;
  roughness?: Maybe<Scalars["String"]>;
  serialNumber?: Maybe<Scalars["String"]>;
  shape?: Maybe<Scalars["String"]>;
  size?: Maybe<Scalars["String"]>;
  structuralDesignSupervisionAndChecking?: Maybe<Scalars["String"]>;
  structuralMaterial?: Maybe<Scalars["String"]>;
  structure?: Maybe<Scalars["String"]>;
  sustainabilityPerformance?: Maybe<Scalars["String"]>;
  systemAccessories?: Maybe<Scalars["String"]>;
  systemManufacturer?: Maybe<Scalars["String"]>;
  systemType?: Maybe<Scalars["String"]>;
  tagNumber?: Maybe<Scalars["String"]>;
  thermalMass?: Maybe<Scalars["String"]>;
  thermalPerformance?: Maybe<Scalars["String"]>;
  thermalResistance?: Maybe<Scalars["String"]>;
  typeComments?: Maybe<Scalars["String"]>;
  typeImage?: Maybe<Scalars["String"]>;
  typeMark?: Maybe<Scalars["String"]>;
  typeOfAnchor?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
  uValue?: Maybe<Scalars["Float"]>;
  value?: Maybe<Scalars["String"]>;
  vapourControlLayer?: Maybe<Scalars["String"]>;
  warrantyDescription?: Maybe<Scalars["String"]>;
  warrantyDurationLabour?: Maybe<Scalars["String"]>;
  warrantyDurationParts?: Maybe<Scalars["String"]>;
  warrantyDurationUnit?: Maybe<Scalars["String"]>;
  warrantyGuarantorLabour?: Maybe<Scalars["String"]>;
  warrantyGuarantorParts?: Maybe<Scalars["String"]>;
  warrantyStartDate?: Maybe<Scalars["String"]>;
  wallWidth?: Maybe<Scalars["Float"]>;
  width?: Maybe<Scalars["String"]>;
  wrappingAtEnds?: Maybe<Scalars["String"]>;
  wrappingAtInserts?: Maybe<Scalars["String"]>;
};

export type UpdateBuildupLayersInput = {
  layers?: Maybe<Array<Maybe<UpdateLayerInput>>>;
  buildupId?: Maybe<Scalars["String"]>;
  layersToDelete?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type UpdateBuildupTemplate = {
  id?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  parameters?: Maybe<Array<Maybe<Scalars["String"]>>>;
  images?: Maybe<UpdateImagesInput>;
};

export type UpdateImagesInput = {
  toBeAdded?: Maybe<Array<Maybe<Scalars["Upload"]>>>;
  toBeRemoved?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type UpdateLayerInput = {
  id?: Maybe<Scalars["String"]>;
  arrayIndex: Scalars["Float"];
  revitFunction: AllowedRevitFunction;
  material: Scalars["String"];
  width: Scalars["Float"];
  wraps: Scalars["Boolean"];
  structuralMaterial: Scalars["Boolean"];
  buildupId?: Maybe<Scalars["String"]>;
};

export type User = {
  id?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  email_verified?: Maybe<Scalars["Boolean"]>;
  username?: Maybe<Scalars["String"]>;
  phone_number?: Maybe<Scalars["String"]>;
  phone_verified?: Maybe<Scalars["Boolean"]>;
  user_id?: Maybe<Scalars["String"]>;
  created_at?: Maybe<Scalars["String"]>;
  updated_at?: Maybe<Scalars["String"]>;
  picture?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  nickname?: Maybe<Scalars["String"]>;
  last_ip?: Maybe<Scalars["String"]>;
  last_login?: Maybe<Scalars["String"]>;
  logins_count?: Maybe<Scalars["Int"]>;
  blocked?: Maybe<Scalars["Boolean"]>;
  given_name?: Maybe<Scalars["String"]>;
  family_name?: Maybe<Scalars["String"]>;
  permissions?: Maybe<Array<Maybe<Scalars["String"]>>>;
};
export type CheckLatestBuildupChangesQueryVariables = {
  lastDateCheck?: Maybe<Scalars["String"]>;
};

export type CheckLatestBuildupChangesQuery = { __typename?: "Query" } & {
  checkLatestBuildupChanges: {
    __typename?: "CheckLatestBuildupChangesResponse";
  } & {
    buildups: Maybe<
      Array<
        Maybe<
          { __typename?: "Buildup" } & Pick<
            Buildup,
            | "id"
            | "name"
            | "description"
            | "isArchived"
            | "absorptance"
            | "accessibilityPerformance"
            | "acousticPerformanceRw"
            | "acousticPerformanceRwCtr"
            | "airTightnessPerformance"
            | "assemblyCode"
            | "assemblyDescription"
            | "assetIdentifier"
            | "assetType"
            | "author"
            | "barCode"
            | "bimObjectName"
            | "bimspecGuid"
            | "bsBibleVersion"
            | "cavitySize"
            | "claddingType"
            | "coarseScaleFillColor"
            | "coarseScaleFillPattern"
            | "codePerformance"
            | "colour"
            | "connectionAccessories"
            | "connectionFasteners"
            | "constituents"
            | "constructionType"
            | "cost"
            | "createdBy"
            | "currentRevision"
            | "designOfFramingSystems"
            | "dimensionalConstraints"
            | "distributedBy"
            | "durationUnit"
            | "expectedLife"
            | "externalAirGap"
            | "externalBracketCentres"
            | "externalCladdingMaterial"
            | "externalCladdingRestraint"
            | "externalInsulation"
            | "externalSheathingBoard"
            | "features"
            | "finish"
            | "firePerformanceExternalFaceInsulation"
            | "firePerformanceExternalFaceIntegrity"
            | "firePerformanceExternalFaceLoadBearing"
            | "firePerformanceInsideFaceInsulation"
            | "firePerformanceInsideFaceIntegrity"
            | "firePerformanceInsideFaceLoadBearing"
            | "fireRating"
            | "framing"
            | "framingMembers"
            | "function"
            | "gapBetweenWallLinerAndFraming"
            | "grade"
            | "heatTransferCoefficient"
            | "ifcExportAs"
            | "ifcExportType"
            | "independentWallLiner"
            | "installationDate"
            | "insulationBetweenFraming"
            | "insulationBetweenStuds"
            | "insulationThickness"
            | "insulationInternalManufacturer"
            | "insulationExternalManufacturer"
            | "keynote"
            | "liningsFaceLayer"
            | "liningsFasteners"
            | "liningsInnerLayers"
            | "manufacturer"
            | "material"
            | "meansOfAdjustment"
            | "metwallTag"
            | "model"
            | "modelNumber"
            | "modelReference"
            | "movementJointConnections"
            | "nbsDescription"
            | "nbsNote"
            | "nbsOfficeMasterTag"
            | "nbsReference"
            | "nominalHeight"
            | "nominalLength"
            | "nominalWidth"
            | "plasterboardManufacturer"
            | "plasterboardType"
            | "plasterboardThickness"
            | "replacementCost"
            | "roughness"
            | "serialNumber"
            | "shape"
            | "size"
            | "structuralDesignSupervisionAndChecking"
            | "structuralMaterial"
            | "structure"
            | "sustainabilityPerformance"
            | "systemAccessories"
            | "systemManufacturer"
            | "systemType"
            | "tagNumber"
            | "thermalMass"
            | "thermalPerformance"
            | "thermalResistance"
            | "typeComments"
            | "typeImage"
            | "typeMark"
            | "typeOfAnchor"
            | "url"
            | "uValue"
            | "value"
            | "vapourControlLayer"
            | "wallWidth"
            | "warrantyDescription"
            | "warrantyDurationLabour"
            | "warrantyDurationParts"
            | "warrantyDurationUnit"
            | "warrantyGuarantorLabour"
            | "warrantyGuarantorParts"
            | "warrantyStartDate"
            | "width"
            | "wrappingAtEnds"
            | "wrappingAtInserts"
          > & {
              template: Maybe<
                { __typename?: "BuildupTemplate" } & Pick<BuildupTemplate, "id">
              >;
            }
        >
      >
    >;
    templates: Maybe<
      Array<
        Maybe<
          { __typename?: "BuildupTemplate" } & Pick<
            BuildupTemplate,
            "id" | "name" | "description" | "parameters"
          > & {
              images: Maybe<
                Array<
                  Maybe<
                    { __typename?: "Image" } & Pick<
                      Image,
                      "id" | "name" | "location"
                    >
                  >
                >
              >;
            }
        >
      >
    >;
  };
};

export type CreateBuildupMutationVariables = {
  template: CreateBuildupInput;
};

export type CreateBuildupMutation = { __typename?: "Mutation" } & {
  createBuildup: { __typename?: "Buildup" } & Pick<
    Buildup,
    "id" | "name" | "description" | "modelNumber" | "material" | "colour"
  > & {
      template: Maybe<
        { __typename?: "BuildupTemplate" } & Pick<BuildupTemplate, "id">
      >;
    };
};

export type DeleteBuildupMutationVariables = {
  id: Scalars["String"];
};

export type DeleteBuildupMutation = { __typename?: "Mutation" } & {
  deleteBuildup: { __typename?: "Buildup" } & Pick<Buildup, "id" | "name">;
};

export type GeneratePdfMutationVariables = {
  input?: Maybe<GeneratePdfInput>;
};

export type GeneratePdfMutation = { __typename?: "Mutation" } & {
  generatePDF: { __typename?: "GeneratePDFResponse" } & Pick<
    GeneratePdfResponse,
    "location"
  >;
};

export type BuildupQueryVariables = {
  id: Scalars["String"];
};

export type BuildupQuery = { __typename?: "Query" } & {
  buildup: { __typename?: "Buildup" } & Pick<
    Buildup,
    | "id"
    | "name"
    | "description"
    | "isArchived"
    | "absorptance"
    | "accessibilityPerformance"
    | "acousticPerformanceRw"
    | "acousticPerformanceRwCtr"
    | "airTightnessPerformance"
    | "assemblyCode"
    | "assemblyDescription"
    | "assetIdentifier"
    | "assetType"
    | "author"
    | "barCode"
    | "bimObjectName"
    | "bimspecGuid"
    | "bsBibleVersion"
    | "cavitySize"
    | "claddingType"
    | "coarseScaleFillColor"
    | "coarseScaleFillPattern"
    | "codePerformance"
    | "colour"
    | "connectionAccessories"
    | "connectionFasteners"
    | "constituents"
    | "constructionType"
    | "cost"
    | "createdBy"
    | "currentRevision"
    | "designOfFramingSystems"
    | "dimensionalConstraints"
    | "distributedBy"
    | "durationUnit"
    | "expectedLife"
    | "externalAirGap"
    | "externalBracketCentres"
    | "externalCladdingMaterial"
    | "externalCladdingRestraint"
    | "externalInsulation"
    | "externalSheathingBoard"
    | "features"
    | "finish"
    | "firePerformanceExternalFaceInsulation"
    | "firePerformanceExternalFaceIntegrity"
    | "firePerformanceExternalFaceLoadBearing"
    | "firePerformanceInsideFaceInsulation"
    | "firePerformanceInsideFaceIntegrity"
    | "firePerformanceInsideFaceLoadBearing"
    | "fireRating"
    | "framing"
    | "framingMembers"
    | "function"
    | "gapBetweenWallLinerAndFraming"
    | "grade"
    | "heatTransferCoefficient"
    | "ifcExportAs"
    | "ifcExportType"
    | "independentWallLiner"
    | "installationDate"
    | "insulationBetweenFraming"
    | "insulationBetweenStuds"
    | "insulationThickness"
    | "insulationInternalManufacturer"
    | "insulationExternalManufacturer"
    | "keynote"
    | "liningsFaceLayer"
    | "liningsFasteners"
    | "liningsInnerLayers"
    | "manufacturer"
    | "material"
    | "meansOfAdjustment"
    | "metwallTag"
    | "model"
    | "modelNumber"
    | "modelReference"
    | "movementJointConnections"
    | "nbsDescription"
    | "nbsNote"
    | "nbsOfficeMasterTag"
    | "nbsReference"
    | "nominalHeight"
    | "nominalLength"
    | "nominalWidth"
    | "plasterboardManufacturer"
    | "plasterboardType"
    | "plasterboardThickness"
    | "replacementCost"
    | "roughness"
    | "serialNumber"
    | "shape"
    | "size"
    | "structuralDesignSupervisionAndChecking"
    | "structuralMaterial"
    | "structure"
    | "sustainabilityPerformance"
    | "systemAccessories"
    | "systemManufacturer"
    | "systemType"
    | "tagNumber"
    | "thermalMass"
    | "thermalPerformance"
    | "thermalResistance"
    | "typeComments"
    | "typeImage"
    | "typeMark"
    | "typeOfAnchor"
    | "url"
    | "uValue"
    | "value"
    | "vapourControlLayer"
    | "wallWidth"
    | "warrantyDescription"
    | "warrantyDurationLabour"
    | "warrantyDurationParts"
    | "warrantyDurationUnit"
    | "warrantyGuarantorLabour"
    | "warrantyGuarantorParts"
    | "warrantyStartDate"
    | "width"
    | "wrappingAtEnds"
    | "wrappingAtInserts"
  > & {
      template: Maybe<
        { __typename?: "BuildupTemplate" } & Pick<BuildupTemplate, "id">
      >;
      layers: Maybe<
        Array<
          Maybe<
            { __typename?: "Layer" } & Pick<
              Layer,
              | "arrayIndex"
              | "revitFunction"
              | "width"
              | "wraps"
              | "structuralMaterial"
            > & {
                material: { __typename?: "Material" } & Pick<Material, "name">;
              }
          >
        >
      >;
    };
};

export type BuildupsQueryVariables = {
  search?: Maybe<Scalars["String"]>;
  filters?: Maybe<Array<Maybe<Filter>>>;
};

export type BuildupsQuery = { __typename?: "Query" } & {
  buildups: Array<
    Maybe<
      { __typename?: "Buildup" } & Pick<
        Buildup,
        | "id"
        | "name"
        | "description"
        | "isArchived"
        | "absorptance"
        | "accessibilityPerformance"
        | "acousticPerformanceRw"
        | "acousticPerformanceRwCtr"
        | "airTightnessPerformance"
        | "assemblyCode"
        | "assemblyDescription"
        | "assetIdentifier"
        | "assetType"
        | "author"
        | "barCode"
        | "bimObjectName"
        | "bimspecGuid"
        | "bsBibleVersion"
        | "cavitySize"
        | "claddingType"
        | "coarseScaleFillColor"
        | "coarseScaleFillPattern"
        | "codePerformance"
        | "colour"
        | "connectionAccessories"
        | "connectionFasteners"
        | "constituents"
        | "constructionType"
        | "cost"
        | "createdBy"
        | "currentRevision"
        | "designOfFramingSystems"
        | "dimensionalConstraints"
        | "distributedBy"
        | "durationUnit"
        | "expectedLife"
        | "externalAirGap"
        | "externalBracketCentres"
        | "externalCladdingMaterial"
        | "externalCladdingRestraint"
        | "externalInsulation"
        | "externalSheathingBoard"
        | "features"
        | "finish"
        | "firePerformanceExternalFaceInsulation"
        | "firePerformanceExternalFaceIntegrity"
        | "firePerformanceExternalFaceLoadBearing"
        | "firePerformanceInsideFaceInsulation"
        | "firePerformanceInsideFaceIntegrity"
        | "firePerformanceInsideFaceLoadBearing"
        | "fireRating"
        | "framing"
        | "framingMembers"
        | "function"
        | "gapBetweenWallLinerAndFraming"
        | "grade"
        | "heatTransferCoefficient"
        | "ifcExportAs"
        | "ifcExportType"
        | "independentWallLiner"
        | "installationDate"
        | "insulationBetweenFraming"
        | "insulationBetweenStuds"
        | "insulationThickness"
        | "insulationInternalManufacturer"
        | "insulationExternalManufacturer"
        | "keynote"
        | "liningsFaceLayer"
        | "liningsFasteners"
        | "liningsInnerLayers"
        | "manufacturer"
        | "material"
        | "meansOfAdjustment"
        | "metwallTag"
        | "model"
        | "modelNumber"
        | "modelReference"
        | "movementJointConnections"
        | "nbsDescription"
        | "nbsNote"
        | "nbsOfficeMasterTag"
        | "nbsReference"
        | "nominalHeight"
        | "nominalLength"
        | "nominalWidth"
        | "plasterboardManufacturer"
        | "plasterboardType"
        | "plasterboardThickness"
        | "replacementCost"
        | "roughness"
        | "serialNumber"
        | "shape"
        | "size"
        | "structuralDesignSupervisionAndChecking"
        | "structuralMaterial"
        | "structure"
        | "sustainabilityPerformance"
        | "systemAccessories"
        | "systemManufacturer"
        | "systemType"
        | "tagNumber"
        | "thermalMass"
        | "thermalPerformance"
        | "thermalResistance"
        | "typeComments"
        | "typeImage"
        | "typeMark"
        | "typeOfAnchor"
        | "url"
        | "uValue"
        | "value"
        | "vapourControlLayer"
        | "wallWidth"
        | "warrantyDescription"
        | "warrantyDurationLabour"
        | "warrantyDurationParts"
        | "warrantyDurationUnit"
        | "warrantyGuarantorLabour"
        | "warrantyGuarantorParts"
        | "warrantyStartDate"
        | "width"
        | "wrappingAtEnds"
        | "wrappingAtInserts"
      > & {
          template: Maybe<
            { __typename?: "BuildupTemplate" } & Pick<BuildupTemplate, "id">
          >;
          layers: Maybe<
            Array<
              Maybe<
                { __typename?: "Layer" } & Pick<
                  Layer,
                  | "arrayIndex"
                  | "revitFunction"
                  | "width"
                  | "wraps"
                  | "structuralMaterial"
                > & {
                    material: { __typename?: "Material" } & Pick<
                      Material,
                      "name"
                    >;
                  }
              >
            >
          >;
        }
    >
  >;
};

export type UpdateBuildupMutationVariables = {
  buildup: UpdateBuildupInput;
};

export type UpdateBuildupMutation = { __typename?: "Mutation" } & {
  updateBuildup: { __typename?: "Buildup" } & Pick<
    Buildup,
    | "id"
    | "name"
    | "description"
    | "isArchived"
    | "absorptance"
    | "accessibilityPerformance"
    | "acousticPerformanceRw"
    | "acousticPerformanceRwCtr"
    | "airTightnessPerformance"
    | "assemblyCode"
    | "assemblyDescription"
    | "assetIdentifier"
    | "assetType"
    | "author"
    | "barCode"
    | "bimObjectName"
    | "bimspecGuid"
    | "bsBibleVersion"
    | "cavitySize"
    | "claddingType"
    | "coarseScaleFillColor"
    | "coarseScaleFillPattern"
    | "codePerformance"
    | "colour"
    | "connectionAccessories"
    | "connectionFasteners"
    | "constituents"
    | "constructionType"
    | "cost"
    | "createdBy"
    | "currentRevision"
    | "designOfFramingSystems"
    | "dimensionalConstraints"
    | "distributedBy"
    | "durationUnit"
    | "expectedLife"
    | "externalAirGap"
    | "externalBracketCentres"
    | "externalCladdingMaterial"
    | "externalCladdingRestraint"
    | "externalInsulation"
    | "externalSheathingBoard"
    | "features"
    | "finish"
    | "firePerformanceExternalFaceInsulation"
    | "firePerformanceExternalFaceIntegrity"
    | "firePerformanceExternalFaceLoadBearing"
    | "firePerformanceInsideFaceInsulation"
    | "firePerformanceInsideFaceIntegrity"
    | "firePerformanceInsideFaceLoadBearing"
    | "fireRating"
    | "framing"
    | "framingMembers"
    | "function"
    | "gapBetweenWallLinerAndFraming"
    | "grade"
    | "heatTransferCoefficient"
    | "ifcExportAs"
    | "ifcExportType"
    | "independentWallLiner"
    | "installationDate"
    | "insulationBetweenFraming"
    | "insulationBetweenStuds"
    | "insulationThickness"
    | "insulationInternalManufacturer"
    | "insulationExternalManufacturer"
    | "keynote"
    | "liningsFaceLayer"
    | "liningsFasteners"
    | "liningsInnerLayers"
    | "manufacturer"
    | "material"
    | "meansOfAdjustment"
    | "metwallTag"
    | "model"
    | "modelNumber"
    | "modelReference"
    | "movementJointConnections"
    | "nbsDescription"
    | "nbsNote"
    | "nbsOfficeMasterTag"
    | "nbsReference"
    | "nominalHeight"
    | "nominalLength"
    | "nominalWidth"
    | "plasterboardManufacturer"
    | "plasterboardType"
    | "plasterboardThickness"
    | "replacementCost"
    | "roughness"
    | "serialNumber"
    | "shape"
    | "size"
    | "structuralDesignSupervisionAndChecking"
    | "structuralMaterial"
    | "structure"
    | "sustainabilityPerformance"
    | "systemAccessories"
    | "systemManufacturer"
    | "systemType"
    | "tagNumber"
    | "thermalMass"
    | "thermalPerformance"
    | "thermalResistance"
    | "typeComments"
    | "typeImage"
    | "typeMark"
    | "typeOfAnchor"
    | "url"
    | "uValue"
    | "value"
    | "vapourControlLayer"
    | "wallWidth"
    | "warrantyDescription"
    | "warrantyDurationLabour"
    | "warrantyDurationParts"
    | "warrantyDurationUnit"
    | "warrantyGuarantorLabour"
    | "warrantyGuarantorParts"
    | "warrantyStartDate"
    | "width"
    | "wrappingAtEnds"
    | "wrappingAtInserts"
  > & {
      layers: Maybe<
        Array<
          Maybe<
            { __typename?: "Layer" } & Pick<
              Layer,
              | "id"
              | "arrayIndex"
              | "revitFunction"
              | "width"
              | "wraps"
              | "structuralMaterial"
            > & {
                material: { __typename?: "Material" } & Pick<
                  Material,
                  "id" | "name"
                >;
              }
          >
        >
      >;
    };
};

export type CreateBuildupTemplateMutationVariables = {
  template: CreateBuildupTemplate;
};

export type CreateBuildupTemplateMutation = { __typename?: "Mutation" } & {
  createBuildupTemplate: { __typename?: "BuildupTemplate" } & Pick<
    BuildupTemplate,
    "id" | "name" | "description" | "parameters"
  > & {
      images: Maybe<
        Array<
          Maybe<
            { __typename?: "Image" } & Pick<Image, "id" | "name" | "location">
          >
        >
      >;
    };
};

export type DeleteBuildupTemplateMutationVariables = {
  id: Scalars["String"];
};

export type DeleteBuildupTemplateMutation = { __typename?: "Mutation" } & {
  deleteBuildupTemplate: { __typename?: "BuildupTemplate" } & Pick<
    BuildupTemplate,
    "id" | "name"
  >;
};

export type BuildupTemplateQueryVariables = {
  id: Scalars["String"];
};

export type BuildupTemplateQuery = { __typename?: "Query" } & {
  buildupTemplate: { __typename?: "BuildupTemplate" } & Pick<
    BuildupTemplate,
    "id" | "name" | "description" | "parameters"
  > & {
      images: Maybe<
        Array<
          Maybe<
            { __typename?: "Image" } & Pick<Image, "id" | "name" | "location">
          >
        >
      >;
    };
};

export type BuildupTemplatesQueryVariables = {
  page: Scalars["Int"];
};

export type BuildupTemplatesQuery = { __typename?: "Query" } & {
  buildupTemplates: Array<
    Maybe<
      { __typename?: "BuildupTemplate" } & Pick<
        BuildupTemplate,
        "id" | "name" | "description" | "parameters"
      > & {
          images: Maybe<
            Array<
              Maybe<
                { __typename?: "Image" } & Pick<
                  Image,
                  "id" | "name" | "location"
                >
              >
            >
          >;
        }
    >
  >;
};

export type UpdateBuildupTemplateMutationVariables = {
  template: UpdateBuildupTemplate;
};

export type UpdateBuildupTemplateMutation = { __typename?: "Mutation" } & {
  updateBuildupTemplate: { __typename?: "BuildupTemplate" } & Pick<
    BuildupTemplate,
    "id" | "name" | "description"
  >;
};

export type CreateUserMutationVariables = {
  data: CreateUserInput;
};

export type CreateUserMutation = { __typename?: "Mutation" } & {
  createUser: Maybe<
    { __typename?: "User" } & Pick<
      User,
      | "blocked"
      | "created_at"
      | "email"
      | "email_verified"
      | "family_name"
      | "given_name"
      | "last_ip"
      | "last_login"
      | "logins_count"
      | "name"
      | "nickname"
      | "phone_number"
      | "phone_verified"
      | "picture"
      | "updated_at"
      | "user_id"
      | "username"
    >
  >;
};

export type GetUserQueryVariables = {
  id: Scalars["String"];
};

export type GetUserQuery = { __typename?: "Query" } & {
  user: Maybe<
    { __typename?: "User" } & Pick<
      User,
      | "blocked"
      | "created_at"
      | "email_verified"
      | "email"
      | "family_name"
      | "given_name"
      | "id"
      | "last_ip"
      | "last_login"
      | "logins_count"
      | "name"
      | "nickname"
      | "phone_number"
      | "phone_verified"
      | "picture"
      | "updated_at"
      | "user_id"
      | "username"
    >
  >;
};

export type GetUsersQueryVariables = {};

export type GetUsersQuery = { __typename?: "Query" } & {
  users: Maybe<
    Array<
      Maybe<
        { __typename?: "User" } & Pick<
          User,
          | "blocked"
          | "created_at"
          | "email"
          | "email_verified"
          | "family_name"
          | "given_name"
          | "last_ip"
          | "last_login"
          | "logins_count"
          | "name"
          | "nickname"
          | "phone_number"
          | "phone_verified"
          | "picture"
          | "updated_at"
          | "user_id"
          | "username"
        >
      >
    >
  >;
};

export type MeQueryVariables = {};

export type MeQuery = { __typename?: "Query" } & {
  me: Maybe<{ __typename?: "User" } & Pick<User, "permissions">>;
};

export type ResetPasswordMutationVariables = {
  id: Scalars["String"];
};

export type ResetPasswordMutation = { __typename?: "Mutation" } & Pick<
  Mutation,
  "resetPassword"
>;

import gql from "graphql-tag";
import * as React from "react";
import * as ReactApollo from "react-apollo";

export const CheckLatestBuildupChangesDocument = gql`
  query checkLatestBuildupChanges($lastDateCheck: String) {
    checkLatestBuildupChanges(input: { lastDateCheck: $lastDateCheck }) {
      buildups {
        id
        name
        description
        template {
          id
        }
        isArchived
        absorptance
        accessibilityPerformance
        acousticPerformanceRw
        acousticPerformanceRwCtr
        airTightnessPerformance
        assemblyCode
        assemblyDescription
        assetIdentifier
        assetType
        author
        barCode
        bimObjectName
        bimspecGuid
        bsBibleVersion
        cavitySize
        claddingType
        coarseScaleFillColor
        coarseScaleFillPattern
        codePerformance
        colour
        connectionAccessories
        connectionFasteners
        constituents
        constructionType
        cost
        createdBy
        currentRevision
        designOfFramingSystems
        dimensionalConstraints
        distributedBy
        durationUnit
        expectedLife
        externalAirGap
        externalBracketCentres
        externalCladdingMaterial
        externalCladdingRestraint
        externalInsulation
        externalSheathingBoard
        features
        finish
        firePerformanceExternalFaceInsulation
        firePerformanceExternalFaceIntegrity
        firePerformanceExternalFaceLoadBearing
        firePerformanceInsideFaceInsulation
        firePerformanceInsideFaceIntegrity
        firePerformanceInsideFaceLoadBearing
        fireRating
        framing
        framingMembers
        function
        gapBetweenWallLinerAndFraming
        grade
        heatTransferCoefficient
        ifcExportAs
        ifcExportType
        independentWallLiner
        installationDate
        insulationBetweenFraming
        insulationBetweenStuds
        insulationThickness
        insulationInternalManufacturer
        insulationExternalManufacturer
        keynote
        liningsFaceLayer
        liningsFasteners
        liningsInnerLayers
        manufacturer
        material
        meansOfAdjustment
        metwallTag
        model
        modelNumber
        modelReference
        movementJointConnections
        nbsDescription
        nbsNote
        nbsOfficeMasterTag
        nbsReference
        nominalHeight
        nominalLength
        nominalWidth
        plasterboardManufacturer
        plasterboardType
        plasterboardThickness
        replacementCost
        roughness
        serialNumber
        shape
        size
        structuralDesignSupervisionAndChecking
        structuralMaterial
        structure
        sustainabilityPerformance
        systemAccessories
        systemManufacturer
        systemType
        tagNumber
        thermalMass
        thermalPerformance
        thermalResistance
        typeComments
        typeImage
        typeMark
        typeOfAnchor
        url
        uValue
        value
        vapourControlLayer
        wallWidth
        warrantyDescription
        warrantyDurationLabour
        warrantyDurationParts
        warrantyDurationUnit
        warrantyGuarantorLabour
        warrantyGuarantorParts
        warrantyStartDate
        width
        wrappingAtEnds
        wrappingAtInserts
      }
      templates {
        id
        name
        description
        parameters
        images {
          id
          name
          location
        }
      }
    }
  }
`;

export class CheckLatestBuildupChangesComponent extends React.Component<
  Partial<
    ReactApollo.QueryProps<
      CheckLatestBuildupChangesQuery,
      CheckLatestBuildupChangesQueryVariables
    >
  >
> {
  render() {
    return (
      <ReactApollo.Query<
        CheckLatestBuildupChangesQuery,
        CheckLatestBuildupChangesQueryVariables
      >
        query={CheckLatestBuildupChangesDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type CheckLatestBuildupChangesProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<
    CheckLatestBuildupChangesQuery,
    CheckLatestBuildupChangesQueryVariables
  >
> &
  TChildProps;
export function withCheckLatestBuildupChanges<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        CheckLatestBuildupChangesQuery,
        CheckLatestBuildupChangesQueryVariables,
        CheckLatestBuildupChangesProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withQuery<
    TProps,
    CheckLatestBuildupChangesQuery,
    CheckLatestBuildupChangesQueryVariables,
    CheckLatestBuildupChangesProps<TChildProps>
  >(CheckLatestBuildupChangesDocument, operationOptions);
}
export const CreateBuildupDocument = gql`
  mutation createBuildup($template: CreateBuildupInput!) {
    createBuildup(input: $template) {
      id
      name
      description
      modelNumber
      material
      colour
      template {
        id
      }
    }
  }
`;

export class CreateBuildupComponent extends React.Component<
  Partial<
    ReactApollo.MutationProps<
      CreateBuildupMutation,
      CreateBuildupMutationVariables
    >
  >
> {
  render() {
    return (
      <ReactApollo.Mutation<
        CreateBuildupMutation,
        CreateBuildupMutationVariables
      >
        mutation={CreateBuildupDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type CreateBuildupProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreateBuildupMutation, CreateBuildupMutationVariables>
> &
  TChildProps;
export type CreateBuildupMutationFn = ReactApollo.MutationFn<
  CreateBuildupMutation,
  CreateBuildupMutationVariables
>;
export function withCreateBuildup<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        CreateBuildupMutation,
        CreateBuildupMutationVariables,
        CreateBuildupProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withMutation<
    TProps,
    CreateBuildupMutation,
    CreateBuildupMutationVariables,
    CreateBuildupProps<TChildProps>
  >(CreateBuildupDocument, operationOptions);
}
export const DeleteBuildupDocument = gql`
  mutation deleteBuildup($id: String!) {
    deleteBuildup(id: $id) {
      id
      name
    }
  }
`;

export class DeleteBuildupComponent extends React.Component<
  Partial<
    ReactApollo.MutationProps<
      DeleteBuildupMutation,
      DeleteBuildupMutationVariables
    >
  >
> {
  render() {
    return (
      <ReactApollo.Mutation<
        DeleteBuildupMutation,
        DeleteBuildupMutationVariables
      >
        mutation={DeleteBuildupDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type DeleteBuildupProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<DeleteBuildupMutation, DeleteBuildupMutationVariables>
> &
  TChildProps;
export type DeleteBuildupMutationFn = ReactApollo.MutationFn<
  DeleteBuildupMutation,
  DeleteBuildupMutationVariables
>;
export function withDeleteBuildup<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        DeleteBuildupMutation,
        DeleteBuildupMutationVariables,
        DeleteBuildupProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withMutation<
    TProps,
    DeleteBuildupMutation,
    DeleteBuildupMutationVariables,
    DeleteBuildupProps<TChildProps>
  >(DeleteBuildupDocument, operationOptions);
}
export const GeneratePdfDocument = gql`
  mutation generatePDF($input: GeneratePDFInput) {
    generatePDF(input: $input) {
      location
    }
  }
`;

export class GeneratePdfComponent extends React.Component<
  Partial<
    ReactApollo.MutationProps<GeneratePdfMutation, GeneratePdfMutationVariables>
  >
> {
  render() {
    return (
      <ReactApollo.Mutation<GeneratePdfMutation, GeneratePdfMutationVariables>
        mutation={GeneratePdfDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type GeneratePdfProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<GeneratePdfMutation, GeneratePdfMutationVariables>
> &
  TChildProps;
export type GeneratePdfMutationFn = ReactApollo.MutationFn<
  GeneratePdfMutation,
  GeneratePdfMutationVariables
>;
export function withGeneratePdf<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        GeneratePdfMutation,
        GeneratePdfMutationVariables,
        GeneratePdfProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withMutation<
    TProps,
    GeneratePdfMutation,
    GeneratePdfMutationVariables,
    GeneratePdfProps<TChildProps>
  >(GeneratePdfDocument, operationOptions);
}
export const BuildupDocument = gql`
  query buildup($id: String!) {
    buildup(id: $id) {
      id
      name
      description
      template {
        id
      }
      layers {
        arrayIndex
        revitFunction
        width
        wraps
        material {
          name
        }
        structuralMaterial
      }
      isArchived
      absorptance
      accessibilityPerformance
      acousticPerformanceRw
      acousticPerformanceRwCtr
      airTightnessPerformance
      assemblyCode
      assemblyDescription
      assetIdentifier
      assetType
      author
      barCode
      bimObjectName
      bimspecGuid
      bsBibleVersion
      cavitySize
      claddingType
      coarseScaleFillColor
      coarseScaleFillPattern
      codePerformance
      colour
      connectionAccessories
      connectionFasteners
      constituents
      constructionType
      cost
      createdBy
      currentRevision
      designOfFramingSystems
      dimensionalConstraints
      distributedBy
      durationUnit
      expectedLife
      externalAirGap
      externalBracketCentres
      externalCladdingMaterial
      externalCladdingRestraint
      externalInsulation
      externalSheathingBoard
      features
      finish
      firePerformanceExternalFaceInsulation
      firePerformanceExternalFaceIntegrity
      firePerformanceExternalFaceLoadBearing
      firePerformanceInsideFaceInsulation
      firePerformanceInsideFaceIntegrity
      firePerformanceInsideFaceLoadBearing
      fireRating
      framing
      framingMembers
      function
      gapBetweenWallLinerAndFraming
      grade
      heatTransferCoefficient
      ifcExportAs
      ifcExportType
      independentWallLiner
      installationDate
      insulationBetweenFraming
      insulationBetweenStuds
      insulationThickness
      insulationInternalManufacturer
      insulationExternalManufacturer
      keynote
      liningsFaceLayer
      liningsFasteners
      liningsInnerLayers
      manufacturer
      material
      meansOfAdjustment
      metwallTag
      model
      modelNumber
      modelReference
      movementJointConnections
      nbsDescription
      nbsNote
      nbsOfficeMasterTag
      nbsReference
      nominalHeight
      nominalLength
      nominalWidth
      plasterboardManufacturer
      plasterboardType
      plasterboardThickness
      replacementCost
      roughness
      serialNumber
      shape
      size
      structuralDesignSupervisionAndChecking
      structuralMaterial
      structure
      sustainabilityPerformance
      systemAccessories
      systemManufacturer
      systemType
      tagNumber
      thermalMass
      thermalPerformance
      thermalResistance
      typeComments
      typeImage
      typeMark
      typeOfAnchor
      url
      uValue
      value
      vapourControlLayer
      wallWidth
      warrantyDescription
      warrantyDurationLabour
      warrantyDurationParts
      warrantyDurationUnit
      warrantyGuarantorLabour
      warrantyGuarantorParts
      warrantyStartDate
      width
      wrappingAtEnds
      wrappingAtInserts
    }
  }
`;

export class BuildupComponent extends React.Component<
  Partial<ReactApollo.QueryProps<BuildupQuery, BuildupQueryVariables>>
> {
  render() {
    return (
      <ReactApollo.Query<BuildupQuery, BuildupQueryVariables>
        query={BuildupDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type BuildupProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<BuildupQuery, BuildupQueryVariables>
> &
  TChildProps;
export function withBuildup<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        BuildupQuery,
        BuildupQueryVariables,
        BuildupProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withQuery<
    TProps,
    BuildupQuery,
    BuildupQueryVariables,
    BuildupProps<TChildProps>
  >(BuildupDocument, operationOptions);
}
export const BuildupsDocument = gql`
  query buildups($search: String, $filters: [Filter]) {
    buildups(search: $search, filters: $filters) {
      id
      name
      description
      template {
        id
      }
      layers {
        arrayIndex
        revitFunction
        width
        wraps
        material {
          name
        }
        structuralMaterial
      }
      isArchived
      absorptance
      accessibilityPerformance
      acousticPerformanceRw
      acousticPerformanceRwCtr
      airTightnessPerformance
      assemblyCode
      assemblyDescription
      assetIdentifier
      assetType
      author
      barCode
      bimObjectName
      bimspecGuid
      bsBibleVersion
      cavitySize
      claddingType
      coarseScaleFillColor
      coarseScaleFillPattern
      codePerformance
      colour
      connectionAccessories
      connectionFasteners
      constituents
      constructionType
      cost
      createdBy
      currentRevision
      designOfFramingSystems
      dimensionalConstraints
      distributedBy
      durationUnit
      expectedLife
      externalAirGap
      externalBracketCentres
      externalCladdingMaterial
      externalCladdingRestraint
      externalInsulation
      externalSheathingBoard
      features
      finish
      firePerformanceExternalFaceInsulation
      firePerformanceExternalFaceIntegrity
      firePerformanceExternalFaceLoadBearing
      firePerformanceInsideFaceInsulation
      firePerformanceInsideFaceIntegrity
      firePerformanceInsideFaceLoadBearing
      fireRating
      framing
      framingMembers
      function
      gapBetweenWallLinerAndFraming
      grade
      heatTransferCoefficient
      ifcExportAs
      ifcExportType
      independentWallLiner
      installationDate
      insulationBetweenFraming
      insulationBetweenStuds
      insulationThickness
      insulationInternalManufacturer
      insulationExternalManufacturer
      keynote
      liningsFaceLayer
      liningsFasteners
      liningsInnerLayers
      manufacturer
      material
      meansOfAdjustment
      metwallTag
      model
      modelNumber
      modelReference
      movementJointConnections
      nbsDescription
      nbsNote
      nbsOfficeMasterTag
      nbsReference
      nominalHeight
      nominalLength
      nominalWidth
      plasterboardManufacturer
      plasterboardType
      plasterboardThickness
      replacementCost
      roughness
      serialNumber
      shape
      size
      structuralDesignSupervisionAndChecking
      structuralMaterial
      structure
      sustainabilityPerformance
      systemAccessories
      systemManufacturer
      systemType
      tagNumber
      thermalMass
      thermalPerformance
      thermalResistance
      typeComments
      typeImage
      typeMark
      typeOfAnchor
      url
      uValue
      value
      vapourControlLayer
      wallWidth
      warrantyDescription
      warrantyDurationLabour
      warrantyDurationParts
      warrantyDurationUnit
      warrantyGuarantorLabour
      warrantyGuarantorParts
      warrantyStartDate
      width
      wrappingAtEnds
      wrappingAtInserts
    }
  }
`;

export class BuildupsComponent extends React.Component<
  Partial<ReactApollo.QueryProps<BuildupsQuery, BuildupsQueryVariables>>
> {
  render() {
    return (
      <ReactApollo.Query<BuildupsQuery, BuildupsQueryVariables>
        query={BuildupsDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type BuildupsProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<BuildupsQuery, BuildupsQueryVariables>
> &
  TChildProps;
export function withBuildups<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        BuildupsQuery,
        BuildupsQueryVariables,
        BuildupsProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withQuery<
    TProps,
    BuildupsQuery,
    BuildupsQueryVariables,
    BuildupsProps<TChildProps>
  >(BuildupsDocument, operationOptions);
}
export const UpdateBuildupDocument = gql`
  mutation updateBuildup($buildup: UpdateBuildupInput!) {
    updateBuildup(input: $buildup) {
      id
      name
      description
      layers {
        id
        arrayIndex
        revitFunction
        width
        wraps
        material {
          id
          name
        }
        structuralMaterial
      }
      isArchived
      absorptance
      accessibilityPerformance
      acousticPerformanceRw
      acousticPerformanceRwCtr
      airTightnessPerformance
      assemblyCode
      assemblyDescription
      assetIdentifier
      assetType
      author
      barCode
      bimObjectName
      bimspecGuid
      bsBibleVersion
      cavitySize
      claddingType
      coarseScaleFillColor
      coarseScaleFillPattern
      codePerformance
      colour
      connectionAccessories
      connectionFasteners
      constituents
      constructionType
      cost
      createdBy
      currentRevision
      designOfFramingSystems
      dimensionalConstraints
      distributedBy
      durationUnit
      expectedLife
      externalAirGap
      externalBracketCentres
      externalCladdingMaterial
      externalCladdingRestraint
      externalInsulation
      externalSheathingBoard
      features
      finish
      firePerformanceExternalFaceInsulation
      firePerformanceExternalFaceIntegrity
      firePerformanceExternalFaceLoadBearing
      firePerformanceInsideFaceInsulation
      firePerformanceInsideFaceIntegrity
      firePerformanceInsideFaceLoadBearing
      fireRating
      framing
      framingMembers
      function
      gapBetweenWallLinerAndFraming
      grade
      heatTransferCoefficient
      ifcExportAs
      ifcExportType
      independentWallLiner
      installationDate
      insulationBetweenFraming
      insulationBetweenStuds
      insulationThickness
      insulationInternalManufacturer
      insulationExternalManufacturer
      keynote
      liningsFaceLayer
      liningsFasteners
      liningsInnerLayers
      manufacturer
      material
      meansOfAdjustment
      metwallTag
      model
      modelNumber
      modelReference
      movementJointConnections
      nbsDescription
      nbsNote
      nbsOfficeMasterTag
      nbsReference
      nominalHeight
      nominalLength
      nominalWidth
      plasterboardManufacturer
      plasterboardType
      plasterboardThickness
      replacementCost
      roughness
      serialNumber
      shape
      size
      structuralDesignSupervisionAndChecking
      structuralMaterial
      structure
      sustainabilityPerformance
      systemAccessories
      systemManufacturer
      systemType
      tagNumber
      thermalMass
      thermalPerformance
      thermalResistance
      typeComments
      typeImage
      typeMark
      typeOfAnchor
      url
      uValue
      value
      vapourControlLayer
      wallWidth
      warrantyDescription
      warrantyDurationLabour
      warrantyDurationParts
      warrantyDurationUnit
      warrantyGuarantorLabour
      warrantyGuarantorParts
      warrantyStartDate
      width
      wrappingAtEnds
      wrappingAtInserts
    }
  }
`;

export class UpdateBuildupComponent extends React.Component<
  Partial<
    ReactApollo.MutationProps<
      UpdateBuildupMutation,
      UpdateBuildupMutationVariables
    >
  >
> {
  render() {
    return (
      <ReactApollo.Mutation<
        UpdateBuildupMutation,
        UpdateBuildupMutationVariables
      >
        mutation={UpdateBuildupDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type UpdateBuildupProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<UpdateBuildupMutation, UpdateBuildupMutationVariables>
> &
  TChildProps;
export type UpdateBuildupMutationFn = ReactApollo.MutationFn<
  UpdateBuildupMutation,
  UpdateBuildupMutationVariables
>;
export function withUpdateBuildup<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        UpdateBuildupMutation,
        UpdateBuildupMutationVariables,
        UpdateBuildupProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withMutation<
    TProps,
    UpdateBuildupMutation,
    UpdateBuildupMutationVariables,
    UpdateBuildupProps<TChildProps>
  >(UpdateBuildupDocument, operationOptions);
}
export const CreateBuildupTemplateDocument = gql`
  mutation createBuildupTemplate($template: CreateBuildupTemplate!) {
    createBuildupTemplate(input: $template) {
      id
      name
      description
      parameters
      images {
        id
        name
        location
      }
    }
  }
`;

export class CreateBuildupTemplateComponent extends React.Component<
  Partial<
    ReactApollo.MutationProps<
      CreateBuildupTemplateMutation,
      CreateBuildupTemplateMutationVariables
    >
  >
> {
  render() {
    return (
      <ReactApollo.Mutation<
        CreateBuildupTemplateMutation,
        CreateBuildupTemplateMutationVariables
      >
        mutation={CreateBuildupTemplateDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type CreateBuildupTemplateProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<
    CreateBuildupTemplateMutation,
    CreateBuildupTemplateMutationVariables
  >
> &
  TChildProps;
export type CreateBuildupTemplateMutationFn = ReactApollo.MutationFn<
  CreateBuildupTemplateMutation,
  CreateBuildupTemplateMutationVariables
>;
export function withCreateBuildupTemplate<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        CreateBuildupTemplateMutation,
        CreateBuildupTemplateMutationVariables,
        CreateBuildupTemplateProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withMutation<
    TProps,
    CreateBuildupTemplateMutation,
    CreateBuildupTemplateMutationVariables,
    CreateBuildupTemplateProps<TChildProps>
  >(CreateBuildupTemplateDocument, operationOptions);
}
export const DeleteBuildupTemplateDocument = gql`
  mutation deleteBuildupTemplate($id: String!) {
    deleteBuildupTemplate(id: $id) {
      id
      name
    }
  }
`;

export class DeleteBuildupTemplateComponent extends React.Component<
  Partial<
    ReactApollo.MutationProps<
      DeleteBuildupTemplateMutation,
      DeleteBuildupTemplateMutationVariables
    >
  >
> {
  render() {
    return (
      <ReactApollo.Mutation<
        DeleteBuildupTemplateMutation,
        DeleteBuildupTemplateMutationVariables
      >
        mutation={DeleteBuildupTemplateDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type DeleteBuildupTemplateProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<
    DeleteBuildupTemplateMutation,
    DeleteBuildupTemplateMutationVariables
  >
> &
  TChildProps;
export type DeleteBuildupTemplateMutationFn = ReactApollo.MutationFn<
  DeleteBuildupTemplateMutation,
  DeleteBuildupTemplateMutationVariables
>;
export function withDeleteBuildupTemplate<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        DeleteBuildupTemplateMutation,
        DeleteBuildupTemplateMutationVariables,
        DeleteBuildupTemplateProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withMutation<
    TProps,
    DeleteBuildupTemplateMutation,
    DeleteBuildupTemplateMutationVariables,
    DeleteBuildupTemplateProps<TChildProps>
  >(DeleteBuildupTemplateDocument, operationOptions);
}
export const BuildupTemplateDocument = gql`
  query buildupTemplate($id: String!) {
    buildupTemplate(id: $id) {
      id
      name
      description
      parameters
      images {
        id
        name
        location
      }
    }
  }
`;

export class BuildupTemplateComponent extends React.Component<
  Partial<
    ReactApollo.QueryProps<BuildupTemplateQuery, BuildupTemplateQueryVariables>
  >
> {
  render() {
    return (
      <ReactApollo.Query<BuildupTemplateQuery, BuildupTemplateQueryVariables>
        query={BuildupTemplateDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type BuildupTemplateProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<BuildupTemplateQuery, BuildupTemplateQueryVariables>
> &
  TChildProps;
export function withBuildupTemplate<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        BuildupTemplateQuery,
        BuildupTemplateQueryVariables,
        BuildupTemplateProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withQuery<
    TProps,
    BuildupTemplateQuery,
    BuildupTemplateQueryVariables,
    BuildupTemplateProps<TChildProps>
  >(BuildupTemplateDocument, operationOptions);
}
export const BuildupTemplatesDocument = gql`
  query buildupTemplates($page: Int!) {
    buildupTemplates(page: $page) {
      id
      name
      description
      parameters
      images {
        id
        name
        location
      }
    }
  }
`;

export class BuildupTemplatesComponent extends React.Component<
  Partial<
    ReactApollo.QueryProps<
      BuildupTemplatesQuery,
      BuildupTemplatesQueryVariables
    >
  >
> {
  render() {
    return (
      <ReactApollo.Query<BuildupTemplatesQuery, BuildupTemplatesQueryVariables>
        query={BuildupTemplatesDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type BuildupTemplatesProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<BuildupTemplatesQuery, BuildupTemplatesQueryVariables>
> &
  TChildProps;
export function withBuildupTemplates<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        BuildupTemplatesQuery,
        BuildupTemplatesQueryVariables,
        BuildupTemplatesProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withQuery<
    TProps,
    BuildupTemplatesQuery,
    BuildupTemplatesQueryVariables,
    BuildupTemplatesProps<TChildProps>
  >(BuildupTemplatesDocument, operationOptions);
}
export const UpdateBuildupTemplateDocument = gql`
  mutation updateBuildupTemplate($template: UpdateBuildupTemplate!) {
    updateBuildupTemplate(input: $template) {
      id
      name
      description
    }
  }
`;

export class UpdateBuildupTemplateComponent extends React.Component<
  Partial<
    ReactApollo.MutationProps<
      UpdateBuildupTemplateMutation,
      UpdateBuildupTemplateMutationVariables
    >
  >
> {
  render() {
    return (
      <ReactApollo.Mutation<
        UpdateBuildupTemplateMutation,
        UpdateBuildupTemplateMutationVariables
      >
        mutation={UpdateBuildupTemplateDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type UpdateBuildupTemplateProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<
    UpdateBuildupTemplateMutation,
    UpdateBuildupTemplateMutationVariables
  >
> &
  TChildProps;
export type UpdateBuildupTemplateMutationFn = ReactApollo.MutationFn<
  UpdateBuildupTemplateMutation,
  UpdateBuildupTemplateMutationVariables
>;
export function withUpdateBuildupTemplate<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        UpdateBuildupTemplateMutation,
        UpdateBuildupTemplateMutationVariables,
        UpdateBuildupTemplateProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withMutation<
    TProps,
    UpdateBuildupTemplateMutation,
    UpdateBuildupTemplateMutationVariables,
    UpdateBuildupTemplateProps<TChildProps>
  >(UpdateBuildupTemplateDocument, operationOptions);
}
export const CreateUserDocument = gql`
  mutation CreateUser($data: CreateUserInput!) {
    createUser(data: $data) {
      blocked
      created_at
      email
      email_verified
      family_name
      given_name
      last_ip
      last_login
      logins_count
      name
      nickname
      phone_number
      phone_verified
      picture
      updated_at
      user_id
      username
    }
  }
`;

export class CreateUserComponent extends React.Component<
  Partial<
    ReactApollo.MutationProps<CreateUserMutation, CreateUserMutationVariables>
  >
> {
  render() {
    return (
      <ReactApollo.Mutation<CreateUserMutation, CreateUserMutationVariables>
        mutation={CreateUserDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type CreateUserProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<CreateUserMutation, CreateUserMutationVariables>
> &
  TChildProps;
export type CreateUserMutationFn = ReactApollo.MutationFn<
  CreateUserMutation,
  CreateUserMutationVariables
>;
export function withCreateUser<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        CreateUserMutation,
        CreateUserMutationVariables,
        CreateUserProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withMutation<
    TProps,
    CreateUserMutation,
    CreateUserMutationVariables,
    CreateUserProps<TChildProps>
  >(CreateUserDocument, operationOptions);
}
export const GetUserDocument = gql`
  query getUser($id: String!) {
    user(id: $id) {
      blocked
      created_at
      email_verified
      email
      family_name
      given_name
      id
      last_ip
      last_login
      logins_count
      name
      nickname
      phone_number
      phone_verified
      picture
      updated_at
      user_id
      username
    }
  }
`;

export class GetUserComponent extends React.Component<
  Partial<ReactApollo.QueryProps<GetUserQuery, GetUserQueryVariables>>
> {
  render() {
    return (
      <ReactApollo.Query<GetUserQuery, GetUserQueryVariables>
        query={GetUserDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type GetUserProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetUserQuery, GetUserQueryVariables>
> &
  TChildProps;
export function withGetUser<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        GetUserQuery,
        GetUserQueryVariables,
        GetUserProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withQuery<
    TProps,
    GetUserQuery,
    GetUserQueryVariables,
    GetUserProps<TChildProps>
  >(GetUserDocument, operationOptions);
}
export const GetUsersDocument = gql`
  query getUsers {
    users {
      blocked
      created_at
      email
      email_verified
      family_name
      given_name
      last_ip
      last_login
      logins_count
      name
      nickname
      phone_number
      phone_verified
      picture
      updated_at
      user_id
      username
    }
  }
`;

export class GetUsersComponent extends React.Component<
  Partial<ReactApollo.QueryProps<GetUsersQuery, GetUsersQueryVariables>>
> {
  render() {
    return (
      <ReactApollo.Query<GetUsersQuery, GetUsersQueryVariables>
        query={GetUsersDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type GetUsersProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<GetUsersQuery, GetUsersQueryVariables>
> &
  TChildProps;
export function withGetUsers<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        GetUsersQuery,
        GetUsersQueryVariables,
        GetUsersProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withQuery<
    TProps,
    GetUsersQuery,
    GetUsersQueryVariables,
    GetUsersProps<TChildProps>
  >(GetUsersDocument, operationOptions);
}
export const MeDocument = gql`
  query me {
    me {
      permissions
    }
  }
`;

export class MeComponent extends React.Component<
  Partial<ReactApollo.QueryProps<MeQuery, MeQueryVariables>>
> {
  render() {
    return (
      <ReactApollo.Query<MeQuery, MeQueryVariables>
        query={MeDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type MeProps<TChildProps = {}> = Partial<
  ReactApollo.DataProps<MeQuery, MeQueryVariables>
> &
  TChildProps;
export function withMe<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        MeQuery,
        MeQueryVariables,
        MeProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withQuery<
    TProps,
    MeQuery,
    MeQueryVariables,
    MeProps<TChildProps>
  >(MeDocument, operationOptions);
}
export const ResetPasswordDocument = gql`
  mutation resetPassword($id: String!) {
    resetPassword(id: $id)
  }
`;

export class ResetPasswordComponent extends React.Component<
  Partial<
    ReactApollo.MutationProps<
      ResetPasswordMutation,
      ResetPasswordMutationVariables
    >
  >
> {
  render() {
    return (
      <ReactApollo.Mutation<
        ResetPasswordMutation,
        ResetPasswordMutationVariables
      >
        mutation={ResetPasswordDocument}
        {...(this as any)["props"] as any}
      />
    );
  }
}
export type ResetPasswordProps<TChildProps = {}> = Partial<
  ReactApollo.MutateProps<ResetPasswordMutation, ResetPasswordMutationVariables>
> &
  TChildProps;
export type ResetPasswordMutationFn = ReactApollo.MutationFn<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export function withResetPassword<TProps, TChildProps = {}>(
  operationOptions:
    | ReactApollo.OperationOption<
        TProps,
        ResetPasswordMutation,
        ResetPasswordMutationVariables,
        ResetPasswordProps<TChildProps>
      >
    | undefined
) {
  return ReactApollo.withMutation<
    TProps,
    ResetPasswordMutation,
    ResetPasswordMutationVariables,
    ResetPasswordProps<TChildProps>
  >(ResetPasswordDocument, operationOptions);
}
